/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtendedTokenGate
 */
export interface ExtendedTokenGate {
    /**
     * The mint of the token needed to unlock
     * @type {string}
     * @memberof ExtendedTokenGate
     */
    tokenMint: string;
    /**
     * The amount of the token needed to unlock
     * @type {number}
     * @memberof ExtendedTokenGate
     */
    tokenAmount: number;
}

/**
 * Check if a given object implements the ExtendedTokenGate interface.
 */
export function instanceOfExtendedTokenGate(value: object): value is ExtendedTokenGate {
    let isInstance = true;
    isInstance = isInstance && "tokenMint" in value && value["tokenMint"] !== undefined;
    isInstance = isInstance && "tokenAmount" in value && value["tokenAmount"] !== undefined;

    return isInstance;
}

export function ExtendedTokenGateFromJSON(json: any): ExtendedTokenGate {
    return ExtendedTokenGateFromJSONTyped(json, false);
}

export function ExtendedTokenGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendedTokenGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tokenMint': json['token_mint'],
        'tokenAmount': json['token_amount'],
    };
}

export function ExtendedTokenGateToJSON(value?: ExtendedTokenGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token_mint': value.tokenMint,
        'token_amount': value.tokenAmount,
    };
}

